import { initializeApp as Init } from "firebase/app";
import { getFirestore as Get } from "firebase/firestore";

const Options = {
    apiKey: "AIzaSyADp2ZMSmtgCH9Tf59UWx-lQCP9nvBo74U",
    authDomain: "the-friend-zone-cafe.firebaseapp.com",
    databaseURL: "https://the-friend-zone-cafe-default-rtdb.firebaseio.com",
    projectId: "the-friend-zone-cafe",
    storageBucket: "the-friend-zone-cafe.firebasestorage.app",
    messagingSenderId: "256729520580",
    appId: "1:256729520580:web:a35a9562699dc348b96c91"
};

const Inited = Init( Options );
export const Firestore = Get( Inited );